import { INVENTORY_TABS } from "@intrasync/inventory-management";
import { isInventoryTabVisible } from "./inventoryTabPolicy";

/**
 * Apply the NTX tab policy to the module's tab config.
 *
 * This is PRESENTATION ONLY. Nothing is unregistered: every service store and
 * view store stays mounted, hidden tabs keep loading their data, and the hub
 * Body still resolves a hidden tab's panel if something navigates to it
 * (`ModuleHubBody` looks the panel up in the full tab list). Locations and
 * Categories in particular are hidden as *screens* while remaining load-bearing
 * data behind Stock Levels and the catalog.
 *
 * `ModuleHubHeader` already filters the strip on `tab.visible !== false` — the
 * hub primitive supports this natively, the inventory tab config just never set
 * the field. So this is a supported configuration, not a workaround, and it
 * needs no package patch.
 *
 * To put a tab back, edit the allowlist in `inventoryTabPolicy.ts` — that's the
 * whole change.
 *
 * Call once during root-store construction, before the hub first renders.
 */
export function applyInventoryTabVisibility(): void {
  for (const tab of INVENTORY_TABS as readonly { id: string; visible?: boolean }[]) {
    tab.visible = isInventoryTabVisible(tab.id);
  }
}

export default applyInventoryTabVisibility;
